import { Monitor, Zap, Clock, QrCode, Trophy, Megaphone, ShoppingCart, HeartHandshake, LayoutDashboard } from "lucide-react";
import RadialOrbitalTimeline from "@/components/ui/radial-orbital-timeline";

const orbitData = [
  {
    id: 1,
    title: "Alcance de Clientes",
    date: "Etapa 1",
    content: "Atraia clientes com um cardápio digital moderno e compartilhável por QR Code.",
    category: "Marketing",
    icon: Megaphone,
    relatedIds: [2],
    status: "completed" as const,
    energy: 100,
  },
  {
    id: 2,
    title: "Venda",
    date: "Etapa 2",
    content: "Feche propostas em 1 minuto com sua loja digital ativa 24x7.",
    category: "Vendas",
    icon: ShoppingCart,
    relatedIds: [1, 3],
    status: "in-progress" as const,
    energy: 85,
  },
  {
    id: 3,
    title: "Pós venda",
    date: "Etapa 3",
    content: "Mantenha o relacionamento vivo e transforme clientes em fãs recorrentes.",
    category: "Relacionamento",
    icon: HeartHandshake,
    relatedIds: [2, 4],
    status: "in-progress" as const,
    energy: 70,
  },
  {
    id: 4,
    title: "Gestão",
    date: "Etapa 4",
    content: "Controle tudo em um só lugar: eventos, financeiro e operação.",
    category: "Gestão",
    icon: LayoutDashboard,
    relatedIds: [3, 1],
    status: "completed" as const,
    energy: 95,
  },
];

const features = [
  {
    icon: Megaphone,
    title: "Alcance de Clientes",
    description:
      "Digitalize a sua loja e tenha um ecossistema de distribuição: indicação, mídia paga, prospecção ativa, e dentro do evento",
  },
  {
    icon: ShoppingCart,
    title: "Venda",
    description:
      "Monte propostas em 1 minuto com ajuda da IA, sem perder a personalização de cada evento, e acompanhe em que etapa do funil seu cliente está.",
  },
  {
    icon: LayoutDashboard,
    title: "Gestão automática",
    description:
      "Pagamento integrado, contrato gerado e atualizado online e CRM completo do seu buffet.",
  },
  {
    icon: HeartHandshake,
    title: "Pós-venda",
    description:
      "Integração com WhatsApp, disparo automático de feedback e visão 360º de cada cliente para ação comercial.",
  },
];


const CardapioDigitalAdvantages = () => {
  return (
    <section className="py-16 md:py-24">
      <div className="container-custom">
        <div className="bg-[#EEFDA3] rounded-3xl p-8 md:p-12 lg:p-16">
          <div className="mb-10 lg:mb-12">
            <div className="flex items-center gap-2 text-sm font-medium text-foreground mb-6">
              <Monitor className="w-5 h-5" />
              <span>Buffet</span>
            </div>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-normal font-heading text-brand-dark leading-tight tracking-tight">
              A tecnologia te apoiando<br />
              em todas as etapas<br />
              do seu buffet
            </h2>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-12 items-center">
            {/* Left content */}
            <div>


              <div className="space-y-6">
                {features.map((feature) => {
                  const Icon = feature.icon;
                  return (
                    <div key={feature.title} className="flex gap-4">
                      <div className="flex-shrink-0 w-10 h-10 rounded-full bg-foreground flex items-center justify-center">
                        <Icon className="w-5 h-5 text-background" />
                      </div>
                      <div>
                        <h3 className="font-bold text-foreground mb-1">
                          {feature.title}
                        </h3>
                        <p className="text-sm text-foreground/70 leading-relaxed">
                          {feature.description}
                        </p>
                      </div>
                    </div>
                  );
                })}
              </div>

              <div className="mt-8">
                <a
                  href="/cadastro-fornecedor"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center rounded-full bg-[#EEFDA3] border-2 border-foreground px-8 py-3 text-sm font-semibold text-foreground shadow-sm hover:bg-foreground hover:text-[#EEFDA3] transition-colors"
                >
                  Agendar Demonstração
                </a>
              </div>
            </div>

            {/* Right orbit */}
            <div className="relative flex items-center justify-center">
              <RadialOrbitalTimeline
                timelineData={orbitData}
                centerLogo="https://qfozcnxbtjjmidhjdepc.supabase.co/storage/v1/object/public/logo/Logo_redondo_estrela.png"
                centerLabel="AmeUp"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CardapioDigitalAdvantages;
